import { RegisterOptions } from 'react-hook-form';

/**
 * Mirrors Interstellar's `CreateFreeswitchStackSchema`. Its global handler turns
 * every pydantic error into a bare `400 bad request`, so the reason a payload was
 * refused only exists here: whatever we let through comes back unexplained.
 */
export const CLIENT_NAME_PATTERN = /^[a-z][a-z0-9_]{2,29}$/;
export const COSMOS_UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const CLIENT_NAME_MESSAGE =
  'Usa 3-30 caracteres: empieza con minuscula y solo minusculas, digitos y _ (sin guiones ni espacios).';
export const COSMOS_UUID_MESSAGE =
  'Debe ser un UUID, por ejemplo 415f964e-a10d-4799-bd43-190d2f9403e5.';

export const clientNameRules: RegisterOptions = {
  required: 'El Client Name es obligatorio.',
  validate: (value: string) => CLIENT_NAME_PATTERN.test(value.trim()) || CLIENT_NAME_MESSAGE,
};

export const cosmosAccountUuidRules: RegisterOptions = {
  required: 'El Cosmos Account UUID es obligatorio.',
  validate: (value: string) => COSMOS_UUID_PATTERN.test(value.trim()) || COSMOS_UUID_MESSAGE,
};

/** Suggests a valid `client_name` from what the user typed, for the error hint. */
export const suggestClientName = (value: string): string => {
  const normalized = value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_]+/g, '_')
    .replace(/^[^a-z]+/, '')
    .replace(/_+/g, '_')
    .replace(/_$/, '')
    .slice(0, 30);
  return CLIENT_NAME_PATTERN.test(normalized) ? normalized : '';
};
